'use strict';

wbApp.factory('securitySvc', ['$http', '$q', '$translate',
    function ($http, $q, $translate) {
        var sf = securityFeatures;
        var user = loggedInUser;
        var signInInProgress = false;
        
        var sfDict = {};

        for (var i = 0; i < sf.length; i++) {
            sfDict[sf[i]] = true;
        }

        return {
            isInRole: function (role) {
                if (angular.isArray(role)) {
                    for (var r = 0; r < role.length; r++) {
                        var er = role[r];
                        if (sfDict[er]) {
                            return true;
                        }
                    }
                    return false;
                } else {
                    if (sfDict[role]) {
                        return true;
                    } else {
                        return false;
                    }
                }
            },

            isAuthenticated: function () {
                return user.isAuthenticated;
            },

            loggedInUser: function () {
                if (!user.isAuthenticated) {
                    return {};
                } else {
                    return user;
                }
            },
            
            idTokenRefreshed: function(firebaseUser) {
                // if (!signInInProgress) {
                //     if (firebaseUser) {
                //         firebaseUser.getIdToken().then(function (token) {
                //             $http({
                //                 method: 'POST',
                //                 url: '/login/signin',
                //                 headers: {
                //                     'Authorization': `Bearer ${token}`
                //                 },
                //             });
                //         });
                //     } else {
                //         $http.post('/login/logout');
                //     }
                // }
            },
            
            passwordValidationRegEx: function() {
                return /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9_!@#$%^&*+=\-'\[\]";~,\.><]{8,40}$/;
            },
            
            signIn: function(email, password) {
                return $q(function (resolve, reject) {
                    signInInProgress = true;
                    
                    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.NONE).then(function () {
                        firebase.auth().signInWithEmailAndPassword(email, password).then(function (userCredential) {
                            if (!userCredential.user.emailVerified) {
                                reject({
                                    code: 'wb/user-email-not-verified',
                                    message: 'User email is not verified.'
                                });
                            } else {
                                userCredential.user.getIdToken().then(function (token) {
                                    $http({
                                        method: 'POST',
                                        url: '/login/signin',
                                        headers: {
                                            'Authorization': `Bearer ${token}`
                                        },
                                    }).success(resolve).error(reject);
                                });
                            }
                        })
                        .catch(function (error) {
                            reject(error);
                        });
                    })
                    .catch(function (error) {
                        reject(error);
                    });
                });
            },

            createUserWithEmailAndPassword: function(email, password) {
                return $q(function (resolve, reject) {
                    firebase.auth().createUserWithEmailAndPassword(email, password).then(function (userCredential) {
                        resolve(userCredential);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
                });
            },

            sendEmailVerificationAuthorizationCode: function(email) {
                return $q(function (resolve, reject) {
                    $http({
                        method: 'POST',
                        url: '/restapi/account/email-verification/send-otp',
                        data: { Email: email },
                        headers: {
                            'x-sec-api-key': 'sdPTPs3XHzB5Fa7KqcK928RN9Rm9zdE97nt3t4r5'
                        },
                    }).success(resolve).error(reject);
                });
            },
            
            sendPasswordResetAuthorizationCode: function(email) {
                return $q(function (resolve, reject) {
                    $http({
                        method: 'POST',
                        url: '/restapi/account/password-reset/send-otp',
                        data: { Email: email },
                        headers: {
                            'x-sec-api-key': 'sdPTPs3XHzB5Fa7KqcK928RN9Rm9zdE97nt3t4r5'
                        },                        
                    }).success(resolve).error(reject);
                });
            },
            
            confirmPasswordReset: function(email, password, otp) {
                return $q(function (resolve, reject) {
                    $http({
                        method: 'POST',
                        url: '/restapi/account/password-reset/validate-otp',
                        data: { Email: email, Otp: otp },
                        headers: {
                            'x-sec-api-key': 'sdPTPs3XHzB5Fa7KqcK928RN9Rm9zdE97nt3t4r5'
                        },
                    }).success(function(success) {
                        firebase.auth().confirmPasswordReset(success.oobCode, password).then(function () {
                            resolve();
                        })
                        .catch(function (error) {
                            reject(error);
                        });
                    }).error(reject);
                });
            },

            confirmEmailVerification: function(email, otp) {
                return $q(function (resolve, reject) {
                    $http({
                        method: 'POST',
                        url: '/restapi/account/email-verification/validate-otp',
                        data: { Email: email, Otp: otp },
                        headers: {
                            'x-sec-api-key': 'sdPTPs3XHzB5Fa7KqcK928RN9Rm9zdE97nt3t4r5'
                        },
                    }).success(function(success) {
                        console.log(success);
                        firebase.auth().applyActionCode(success.oobCode).then(function () {
                            resolve();
                        })
                        .catch(function (error) {
                            reject(error);
                        });
                    }).error(reject);
                });
            },

            gcpErrorCodeToText: function(error, verify) {
                if (!error) {
                    if (verify) {
                        return $translate.instant('TXT_OTP_VERIFY_BUSY');
                    } else {
                        return $translate.instant('TXT_OTP_GENERATE_BUSY');
                    }
                } else if (!!error.title && error.title.includes("One time password does not exist or is expired.")) {
                    return $translate.instant('TXT_OTP_DOES_NOT_EXIST');
                } else if (!!error.title) {
                    return error.title;
                } else if (!!error.code) {
                    switch (error.code) {
                        case 'auth/wrong-password':
                            return $translate.instant('TXT_LOGIN_ERROR_WRONG_PASSWORD');
                        case 'auth/user-not-found':
                            return $translate.instant('TXT_LOGIN_ERROR_USER_NOT_FOUND');
                        case 'auth/too-many-requests':
                        case 'auth/user-disabled':
                            return $translate.instant('TXT_LOGIN_ERROR_USER_DISABLED');
                        case 'auth/invalid-email':
                            return $translate.instant('TXT_LOGIN_ERROR_INVALID_EMAIL');
                        case 'auth/email-already-in-use':
                            return $translate.instant('TXT_EMAIL_IN_USE');
                        case 'auth/weak-password':
                            return $translate.instant('TXT_WEAK_PASSWORD');
                        case 'auth/expired-action-code':
                            return error.message;
                        case 'auth/invalid-action-code':
                            return error.message;
                        default:
                            return error.message;
                    }
                } else {
                    return "Unexpected error";
                }
            },    

            adminLogout: function () {
                firebase.auth().signOut().then(function() {
                    $http({
                        method: 'POST',
                        url: '/Login/Logout'
                    }).success(function (data) {
                        window.location = '/NgAdmin';
                    });
                });
            },            

            logout: function () {
                firebase.auth().signOut().then(function() {
                    $http({
                        method: 'POST',
                        url: '/Login/Logout'
                    }).success(function (data) {
                        window.location = '/';
                    });
                });
            },

            roles: sfDict
        }
    }]);